import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import useSession from 'core/hooks/use-session';
import { FormField } from 'core/components/form';
import SwapButton from 'core/components/swap-button';
import RemoveLockedButton from 'core/components/remove-locked-button';

const defaultItem = {};
const ApplicantActions = ({ index, fieldName, item = defaultItem, removeFromList, onRemove, allowLicensedActions }) => {
  const { values } = useFormikContext();
  const { isAgency, canSwapApplicants } = useSession();

  const showApplicantSwapButton =
    canSwapApplicants && item.isPrimary && values.people?.some((person) => person.isCoApplicant);
  const showCoApplicantCheckbox = !item.isPrimary && !values.people?.find((person) => person.isCoApplicant);

  return (
    <>
      {item.isPrimary && showApplicantSwapButton && (
        <SwapButton mode="big" allowLicensedActions={allowLicensedActions} formikPath="people" />
      )}
      {showCoApplicantCheckbox && (
        <FormField
          type="checkbox"
          id={`${fieldName}.isCoApplicant`}
          name={`${fieldName}.isCoApplicant`}
          label="Co Applicant?"
          mode="light"
        />
      )}
      {!item.isPrimary && !isAgency && (
        <FormField
          type="remove"
          id={fieldName}
          name={fieldName}
          mode="big"
          onClick={() => onRemove(index, removeFromList)}
          fast={false}
        />
      )}
      {!item.isPrimary && isAgency && (
        <RemoveLockedButton mode="big" text="Please contact agency support to remove this person." />
      )}
    </>
  );
};

ApplicantActions.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    isCoApplicant: PropTypes.bool,
    isPrimary: PropTypes.bool
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  removeFromList: PropTypes.func.isRequired,
  allowLicensedActions: PropTypes.bool.isRequired
};

export default ApplicantActions;
